<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>
<style type="text/css">
        .el-container .el-header{
            z-index: 999;
        }
        .el-main .main-content {
            background: transparent;
        }
        .el-main .content-body{color: #2d2d2d;}
        .el-main{padding: 15px 20px !important;}
        .nav-list.el-menu--horizontal>.el-menu-item a{ padding:  0 20px; }
        .nav-list.el-menu--horizontal>.el-menu-item{padding: 0;}
        .el-message{top: 75px !important;}
</style>